const pad = (n) => String(n).padStart(2, '0');

// Returns YYYY-MM-DD using the local calendar day (no UTC conversion).
const toLocalISODate = (date = new Date()) => {
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) return date;

  const d = new Date(date);

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

// Deep-clones a payload replacing Date objects with local YYYY-MM-DD strings.
const serializeLocalDates = (value) => {
  if (value instanceof Date) return isNaN(value) ? null : toLocalISODate(value);
  if (Array.isArray(value)) return value.map(serializeLocalDates);
  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, serializeLocalDates(v)]));
  }

  return value;
};

export { toLocalISODate, serializeLocalDates };
